<template>
    <v-dialog width="1000px" :value="value" @input="toggleModal" persistent scrollable>
        <v-card color="kbLight">
            <v-toolbar flat color="kbBlue" dark>
                <div class="text-h6">{{$t('general.insertFormOnWebSite')}}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal(false)">
                    <v-icon>clear</v-icon>
                </v-btn>

                <template v-slot:extension>
                    <v-tabs fixed-tabs v-model="selectedTab">
                        <v-tab>{{$t('general.personalization')}}</v-tab>
                        <v-tab>{{$t('general.injectableCode')}}</v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>

            <v-divider/>

            <v-card-text>
                <v-tabs-items v-model="selectedTab">
                    <v-tab-item>
                        <v-card color="kbWhite" flat>
                            <v-card-text>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-alert :value="true" color="info" dark type="info">
                                            {{$t('general.customYourFormAndInsertGeneratedCodeOnTheNextTab')}}
                                        </v-alert>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-select :label="$t('general.style')"
                                                  color="kbDarkBlueText"
                                                  :items="styles"
                                                  item-text="label"
                                                  item-value="value"
                                                  v-model="settings.style">
                                        </v-select>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field v-model="settings.submitSuccessText"
                                                      color="kbDarkBlueText"
                                                      :label="$t('general.responseMessageSent')">
                                        </v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <h3 class="kbDarkBlueText--text">{{$t('general.sendButton')}}</h3>
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-select v-model="settings.sendButtonSize"
                                                  color="kbDarkBlueText"
                                                  :items="sendButtonSizeItems"
                                                  :label="$t('general.length')">
                                        </v-select>
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-select v-model="settings.sendButtonAlignment"
                                                  color="kbDarkBlueText"
                                                  :items="sendButtonAlignmentItems"
                                                  :label="$t('general.alignment')">
                                        </v-select>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field v-model="settings.sendButtonLabel"
                                                      color="kbDarkBlueText"
                                                      :label="$t('general.label')">
                                        </v-text-field>
                                    </v-col>

                                    <v-col class="text-h6 kbDarkBlueText--text" cols="12">
                                        {{$t('general.selectFormColor')}}
                                    </v-col>

                                    <v-col class="text-center"
                                           cols="12">
                                        <v-color-picker class="ma-2"
                                                        dark
                                                        hide-mode-switch
                                                        mode="hexa"
                                                        width="500px"
                                                        v-model="settings.color">
                                        </v-color-picker>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <v-row class="mt-2" dense>
                                    <v-col class="mb-2" cols="12" >{{$t('general.divWithKeybeFormsToInsertForm')}}</v-col>

                                    <v-row>
                                    <pre class="layout mx-3" v-highlight style="box-shadow: none; border: 2px dashed;">
                                        <code class="col col-12 xml white">{{div}}</code>
                                    </pre>

                                        <v-btn @click="copyScript(div)"
                                               color="kbGray"
                                               style="position: absolute; right: 12px;"
                                               text>
                                            <v-icon left>
                                                file_copy
                                            </v-icon>
                                            {{$t('general.copy')}}
                                        </v-btn>
                                    </v-row>

                                    <v-col cols="12" class="my-2 kbDarkBlueText--text">
                                        {{$t('general.andThenAddTheNextScriptToTheFooter')}}
                                    </v-col>

                                    <v-row>
                                        <pre class="layout mx-3" v-highlight style="box-shadow: none; border: 2px dashed">
                                            <code class="col col-12 xml white">{{script}}</code>
                                        </pre>

                                        <v-btn @click="copyScript(script)"
                                               color="kbGray"
                                               style="position: absolute; right: 12px;"
                                               text>
                                            <v-icon left>
                                                file_copy
                                            </v-icon>
                                            {{$t('general.copy')}}
                                        </v-btn>
                                    </v-row>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>

            <v-divider/>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="mr-2" color="red" outlined @click="toggleModal(false)">{{$t('general.close')}}</v-btn>
                <v-btn color="kbBlue" dark @click="selectedTab = 1">{{$t('general.next')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import scriptForms from '@/libs/scriptForms'
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
export default {
  computed: {
    ...mapState({
      forms: state => state.forms.forms,
      loadingForm: state => state.forms.loadingForm,
      selectedApp: state => state.apps.selectedApp
    }),
    div () {
      return scriptForms.getDivForms()
    },
    sendButtonAlignmentItems () {
      return [
        { text: this.$t('general.left'), value: 'text-left' },
        { text: this.$t('general.center'), value: 'text-center' },
        { text: this.$t('general.right'), value: 'text-right' }
      ]
    },
    sendButtonSizeItems () {
      return [
        { text: this.$t('general.normal'), value: '' },
        { text: this.$t('general.small'), value: 'small' },
        { text: this.$t('general.large'), value: 'large' }
      ]
    },
    styles () {
      return [
        { label: this.$t('general.none'), value: 'none' },
        { label: this.$t('general.normal'), value: 'regular' },
        { label: this.$t('general.solo'), value: 'solo' },
        { label: this.$t('general.outlined'), value: 'outlined' },
        { label: this.$t('general.filled'), value: 'filled' }
      ]
    }
  },
  created () {
    this.settings.color = this.selectedApp.color
    this.updateScript()
  },
  data: () => ({
    script: null,
    selectedTab: '',
    settings: {
      color: '',
      sendButtonAlignment: '',
      sendButtonLabel: '',
      sendButtonSize: '',
      style: '',
      submitSuccessText: ''
    }
  }),
  methods: {
    copyScript (text) {
      navigator.clipboard.writeText(text).then(() => {
        notifications.success(this.$t('general.copiedScript'))
      }).catch(() => {
        notifications.error(this.$t('general.errorCopyingScript'))
      })
    },
    toggleModal (value) {
      this.$emit('cancelAttach')
      this.$emit('input', value)
    },
    updateScript () {
      this.script = scriptForms.getScriptForms(this.selectedApp.client_key, this.formId, this.settings)
    }
  },
  props: ['formId', 'value'],
  watch: {
    settings: {
      handler () {
        this.script = null
        this.updateScript()
      },
      deep: true
    }
  }
}
</script>
